import React, { useEffect, useState } from "react";
import Modal from "../../../Modal/Modal";
import Button from "../../../Buttons/Button";
import QbAnimationLoading from "./QbAnimationLoading";

const QbDocument = ({ onClose, isOpen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessed, setIsProcessed] = useState(false);

  const processQbDocument = () => {
    // Simulate API call
    return new Promise((resolve) => {
      setTimeout(resolve, 2000);
    });
  };

  useEffect(() => {
    if (isOpen && !isProcessed) {
      handleSubmit();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setIsLoading(false);
      setIsProcessed(false);
    }
  }, [isOpen]);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await processQbDocument();
      setIsProcessed(true);
    } catch (error) {
      console.error("QB processing failed:", error);
      // Handle error
    } finally {
      setIsLoading(false);
    }
  };

  // Show loading animation when processing
  if (isLoading) {
    return <QbAnimationLoading isOpen={isOpen} onClose={() => {}} />;
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="ALERT" width="max-w-2xl">
      <div className=" flex flex-col items-center justify-center gap-4">
        <p>Invoice #16464 successfully updated to Quick Books.</p>
        <div className="flex justify-end gap-3 mt-6">
          <Button title={"Close"} onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default QbDocument;
